import type { I18nLocale } from "@/modules/i18n/types"
import type { FunctionComponent } from "react"

import { Breadcrumb } from "@/modules/jobSearchPrefiltered/components/PrefilteredFooter/Breadcrumb/Breadcrumb"
import { Layout } from "@/modules/layouts/components/Layout/Layout"
import { LayoutChild } from "@/modules/layouts/components/Layout/LayoutChild"

type PrefilteredFooterProps = {
  locale: I18nLocale
  baseUrl: string
  homePageLabel: string
  parentPageLabel: string
  currentSlugPageLabel: string
}

export const PrefilteredFooter: FunctionComponent<PrefilteredFooterProps> = ({
  locale,
  baseUrl,
  homePageLabel,
  parentPageLabel,
  currentSlugPageLabel,
}) => {
  return (
    <Layout>
      <LayoutChild variant="full">
        <Breadcrumb
          baseUrl={baseUrl}
          locale={locale}
          homePageLabel={homePageLabel}
          parentPageLabel={parentPageLabel}
          currentSlugPageLabel={currentSlugPageLabel}
        />
      </LayoutChild>
    </Layout>
  )
}
